import React, { useState } from 'react';
import folderIcon from '../../../../assets/DasboardIcons/folder.svg';
import WorkWiseIcon from '../../../ResultComponent/WorkWsieIcon';
import styles from '../../Dashboard.module.css';

const Sidebar = ({ open, onToggle, search, onSearch, onNewDocument, onSharedWithMe, activeItem, onActiveItemChange, onNewFolder, folders }) => {
  const [quickAccessOpen, setQuickAccessOpen] = useState(true);
  const [foldersOpen, setFoldersOpen] = useState(true);

  return (
    <aside className={`${styles.sidebar} ${open ? styles['sidebar-open'] : styles['sidebar-closed']}`} style={{
      position: open ? 'fixed' : 'static',
      zIndex: open ? 30 : 'auto'
    }}>
      {/* Fixed Header Section */}
      <div className={styles['sidebar-header']}>
        {/* Header: match image spacing and layout, keep current sidebar background */}
        <div className={`${styles['sidebar-header-content']} ${open ? styles['sidebar-header-content-open'] : styles['sidebar-header-content-closed']}`}>
          {/* Logo: show full wordmark when open, stripes-only when collapsed */}
          <div className={styles['sidebar-logo']}>
            {open ? (
              <div className={styles['sidebar-logo-mark']} role="img" aria-label="Workwise">
                <WorkWiseIcon
                  logoOnly={false}
                  horizontal
                  width="195"
                  height="52"
                  textColor="currentColor"
                />
              </div>
            ) : (
              <WorkWiseIcon
                width="30"
                height="30"
                logoOnly={true}
                textColor="#000000"
              />
            )}
          </div>
          <button onClick={onToggle} className={`${styles['sidebar-toggle-btn']} ${open ? styles['sidebar-toggle-btn-open'] : styles['sidebar-toggle-btn-closed']}`} aria-label={open ? "Collapse sidebar" : "Expand sidebar"}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className={`${styles['sidebar-toggle-icon']} ${open ? styles['sidebar-toggle-icon-open'] : styles['sidebar-toggle-icon-closed']}`}>
              {open ? (
                <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
              ) : (
                <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9 18l6-6-6-6" />
              )}
            </svg>
          </button>
        </div>

        {open && (
          <>
            <div className={styles['sidebar-actions']}>
              <button onClick={onNewDocument} className={styles['sidebar-create-btn']}>
                <span className={`${styles['text-lg']} leading-none`}>+</span>
                <span className={`${styles['text-sm']} font-medium`}>Create Document</span>
              </button>

              <div className={styles['sidebar-search-container']}>
                <input
                  value={search}
                  onChange={(e) => onSearch(e.target.value)}
                  placeholder="Search documents..."
                  className={styles['sidebar-search-input']}
                />
                <svg className={styles['sidebar-search-icon']} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-4.35-4.35M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                </svg>
              </div>

              <div className={styles['sidebar-divider']}></div>
            </div>
          </>
        )}
      </div>

      {/* Scrollable Content Section */}
      {open && (
        <div className={styles['sidebar-content']}>
          <nav className={styles['sidebar-nav']}>
            <div className={styles['sidebar-section-header']}>
              <span>Quick Access</span>
              <button onClick={() => setQuickAccessOpen(!quickAccessOpen)} className={styles['sidebar-section-toggle']}>
                <svg width="20" height="20" className={styles['sidebar-section-toggle-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  {quickAccessOpen ? (
                    <path d="M6 9l6 6 6-6" />
                  ) : (
                    <path d="M9 6l6 6-6 6" />
                  )}
                </svg>
              </button>
            </div>
            {quickAccessOpen && (
              <ul className={styles['sidebar-nav-list']}>
                <li>
                  <button onClick={() => onActiveItemChange('all-documents')} className={`${styles['sidebar-nav-item']} ${activeItem === 'all-documents' ? styles['sidebar-nav-item-active'] : ''}`}>
                    <svg className={styles['sidebar-nav-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                      <polyline points="14,2 14,8 20,8" />
                    </svg>
                    All Documents
                  </button>
                </li>
                <li>
                  <button onClick={onSharedWithMe} className={`${styles['sidebar-nav-item']} ${activeItem === 'my-drive' ? styles['sidebar-nav-item-active'] : ''}`}>
                    <svg className={styles['sidebar-nav-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
                    </svg>
                    My Drive
                  </button>
                </li>
              </ul>
            )}
          </nav>

          <div className={styles['pt-4']}></div>
          <button onClick={onNewFolder} className={styles['sidebar-create-btn']} style={{ marginTop: '0.75rem' }}>
            <span className={`${styles['text-lg']} leading-none`}>+</span>
            <span className={`${styles['text-sm']} font-medium`}>New Folder</span>
          </button>

          <div className={styles['pt-6']}>
            <div className={styles['sidebar-section-header']}>
              <span>Folders</span>
              <button onClick={() => setFoldersOpen(!foldersOpen)} className={styles['sidebar-section-toggle']}>
                <svg width="20" height="20" className={styles['sidebar-section-toggle-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                  {foldersOpen ? (
                    <path d="M6 9l6 6 6-6" />
                  ) : (
                    <path d="M9 6l6 6-6 6" />
                  )}
                </svg>
              </button>
            </div>
            {foldersOpen && (
              <>
                <ul className={styles['sidebar-nav-list']}>
                  {folders.map((folder) => (
                    <li key={folder.id}>
                      <button onClick={() => onActiveItemChange(folder.id)} className={`${styles['sidebar-nav-item']} ${activeItem === folder.id ? styles['sidebar-nav-item-active'] : ''}`}>
                        <img src={folderIcon} alt="Folder" className={styles['sidebar-nav-icon']} />
                        {folder.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      )}
      {!open && (
        <div className={styles['sidebar-collapsed-actions']}>
          {/* Collapsed icon-only quick actions to ensure visibility */}
          <div className={styles['sidebar-collapsed-section']}>
            {[
              { id: 'docs', name: 'Docs', title: 'Docs', icon: (<svg className={styles['sidebar-collapsed-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25V15A2.25 2.25 0 006.75 17.25h9.879a2.25 2.25 0 001.591-.659l1.53-1.53a2.25 2.25 0 00.659-1.591z" /></svg>) },
              { id: 'sheets', name: 'Sheets', title: 'Sheets', icon: (<svg className={styles['sidebar-collapsed-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M3.75 5.25h16.5M3.75 9.75h16.5M3.75 14.25h16.5M3.75 18.75h16.5" /></svg>) },
              { id: 'slides', name: 'Slides', title: 'Slides', icon: (<svg className={styles['sidebar-collapsed-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="6" width="18" height="12" rx="2" ry="2" strokeWidth="2" /><path d="M12 18v3" strokeWidth="2" /></svg>) },
              { id: 'vids', name: 'Vids', title: 'Vids', icon: (<svg className={styles['sidebar-collapsed-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"><polygon points="5,3 19,12 5,21 5,3" strokeWidth="2" /></svg>) },
              { id: 'forms', name: 'Forms', title: 'Forms', icon: (<svg className={styles['sidebar-collapsed-icon']} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="4" y="4" width="16" height="16" rx="2" strokeWidth="2" /><path d="M8 8h8M8 12h8M8 16h5" strokeWidth="2" /></svg>) },
            ].map((item) => (
              <button key={item.id} className={styles['sidebar-collapsed-btn']} title={item.title}>
                {item.icon}
              </button>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;